import { render, staticRenderFns } from "./ProductManagementPage.vue?vue&type=template&id=575f6562&scoped=true"
import script from "./ProductManagementPage.vue?vue&type=script&lang=js"
export * from "./ProductManagementPage.vue?vue&type=script&lang=js"
import style0 from "./ProductManagementPage.vue?vue&type=style&index=0&id=575f6562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575f6562",
  null
  
)

export default component.exports